import React, { useEffect, useState } from "react"
import { VZMobileBanner } from "../midnight/DiscountFlowModal";
import { TextLink } from "@vds/buttons";
import ReactHtmlParser from 'react-html-parser';

const RibbonBannerRskn = (props) => {

    const { buildProductState, showMnhModal, dispatch, openMnhModal } = props;

    const [showSplOfferBanner, setShowSplOfferBanner] = useState(false);
    const [showTimer, setShowTimer] = useState(false);
    const [aemBannerContent, setAEMBannerContent] = useState("");
    const [timerData, setTimerData] = useState({ day: "", hour: "", min: "", sec: "" })
    const isMobile = window.screen.width < 728

    const deafultBannerContent = buildProductState?.plansPromoFragments["DefaultBanner~DefaultBanner"]?.promo ? ReactHtmlParser(buildProductState?.plansPromoFragments["DefaultBanner~DefaultBanner"]?.promo) : ''

    const isBannerDateInBetween = (start, end) => {
        try {
            const startDate = new Date(`${start?.substring(0, 2)}/${start?.substring(2, 4)}/${start?.substring(4, 8)}`).getTime()
            const endDate = new Date(`${end?.substring(0, 2)}/${end?.substring(2, 4)}/${end?.substring(4, 8)}`).getTime()
            const today = new Date().getTime();
            return today >= startDate && today <= endDate
        }
        catch (error) {
            console.log("Error in isBannerDateInBetween", error)
        }
    }

    const handleTimerLogic = (countdown_enddate) => {
        try {
            const endDateTime = new Date(`${countdown_enddate?.substring(0, 2)}/${countdown_enddate?.substring(2, 4)}/${countdown_enddate?.substring(4, 8)}`).getTime();
            const today = new Date();
            const nytime = today.getTime() + today.getTimezoneOffset() * 60000 + (3600000 * (-5));
            const distance = endDateTime - nytime;
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);
            setTimerData({ day: days, hour: hours, min: minutes, sec: seconds })
            if (distance < 0) {
                setTimerData({ day: "", hour: "", min: "", sec: "" })
            }
        }
        catch (error) {
            console.log("Error in handleTimerLogic", error);
        }
    }

    const handleRibbonBannerLogic = () => {
        try {
            let isBannerOffer = false;
            let banner_startdate = '';
            let banner_enddate = '';
            let countdown_startdate = '';
            let countdown_enddate = '';
            let offerPresent = false;
            if (buildProductState?.internet?.m2mPlans?.length > 0) {
                const sortedPlans = buildProductState?.internet?.m2mPlans?.sort((a, b) => b?.speedCode - a?.speedCode);
                for (const plan of sortedPlans) {
                    isBannerOffer = plan?.specialOffers?.find(offer => {
                        if (offer?.bsOfferId && offer?.bsPromoId && offer?.extendedAttributes?.includes("BANNER")) {
                            offer?.extendedAttributes?.split(',')?.forEach(item => {
                                const [key, value] = item?.split(':');
                                if (key === 'BANNER' && value?.length === 17 && value?.includes("_")) {
                                    [banner_startdate, banner_enddate] = value?.split("_");
                                    if (isBannerDateInBetween(banner_startdate, banner_enddate)) {
                                        offerPresent = true
                                    }
                                }
                            })
                            if (offerPresent) {
                                return offer
                            }
                        }
                    });
                    console.log(isBannerOffer, 'checking isBannerOffer')
                    if (isBannerOffer && isBannerOffer?.bsOfferId && isBannerOffer?.bsPromoId) {
                        isBannerOffer?.extendedAttributes?.split(',')?.forEach(item => {
                            const [key, value] = item?.split(':');
                            if (key === 'BANNER' && value?.length === 17 && value?.includes("_")) {
                                [banner_startdate, banner_enddate] = value?.split("_");
                                if (isBannerDateInBetween(banner_startdate, banner_enddate) && (buildProductState?.plansPromoFragments?.[`${isBannerOffer?.bsPromoId}~${isBannerOffer?.bsOfferId}`]?.promo?.length > 0)) {
                                    setAEMBannerContent(buildProductState?.plansPromoFragments?.[`${isBannerOffer?.bsPromoId}~${isBannerOffer?.bsOfferId}`]?.promo)
                                    setShowSplOfferBanner(true);
                                }
                            }
                            if (key === 'BANNERCOUNTDOWN' && value?.length === 17 && value?.includes("_")) {
                                [countdown_startdate, countdown_enddate] = value?.split("_");
                                if (isBannerDateInBetween(countdown_startdate, countdown_enddate)) {
                                    handleTimerLogic(countdown_enddate);
                                    setInterval(() => { handleTimerLogic(countdown_enddate) }, 1000)
                                    setShowTimer(true);
                                }
                            }
                        });
                        break;
                    }
                }
            }
        }
        catch (error) {
            console.log("Error in handleRibbonBannerLogic", error)
        }
    }

    useEffect(() => {
        try {
            handleRibbonBannerLogic()
        }
        catch (error) {
            console.log("Error in RibbonBannerRskn useEffect", error)
        }
    }, [buildProductState?.internet?.m2mPlans, buildProductState?.plansPromoFragments])

    return (<>
        {(showSplOfferBanner && aemBannerContent) ?
            <><span className="margin-bottom-zero mobileviewbanner"> {ReactHtmlParser(aemBannerContent)}</span>
                {showTimer &&
                    <><span>{isMobile && <br />} Offer ends in</span>
                        {timerData &&
                            <b style={{ color: '#EE0000' }}>
                                &nbsp;{timerData?.day > 1 ? `${timerData?.day} days` : `${timerData?.day} day`} | {timerData?.hour > 1 ? `${timerData?.hour} hrs` : `${timerData?.hour} hr`} | {timerData?.min > 1 ? `${timerData?.min} mins` : `${timerData?.min} min`} | {timerData?.sec > 1 ? `${timerData?.sec} secs` : `${timerData?.sec} sec`}
                            </b>}
                    </>
                }
            </>
            :
            <p className="margin-bottom-zero mnhRibbonBanner" > {deafultBannerContent}
                <span onClick={openMnhModal} id='FOOTER_LEARN' className="pointer" style={{ position: "relative" }}>
                    &nbsp;&#124;&nbsp;<TextLink type="standAlone" tabIndex="0" ref={props.linkRef} role="button" id="detailsRef" ariaLabel="Pair your plans. Get rewarded today with Mobile + Home Rewards opens a modal"><span className="mnhRibbonBanner">Details</span></TextLink>
                </span>
                {showMnhModal && <VZMobileBanner closeBanner={props.closeBanner} signinClicked={props.signinClicked} buildProduct={buildProductState} modalWindow={props?.modalWindow} dispatch={dispatch} />}
            </p>
        }
    </>)
};
export default RibbonBannerRskn;